import React from 'react' 
import useImageLoader from 'hooks/useImageLoader'
import { imgUrl } from 'features/constants'

export default function PostItemImage({image}) {

    const [ imageSource, { blur } ] = useImageLoader(` ${image.urlSmall}`, `${image.url}`)

    return (
        <img 
            className="postItemImageImg" 
            src={imageSource} 
            alt="post"
            style={{
                filter: blur ? 'blur(2px)' : 'none',
                transition: 'all 1s ease-in-out',
            }}
        />  
    )
}
